/**
 * Sensor CrossFrame Listeners
 *
 * Handles CrossFrame requests for sensor operations.
 * Validates required parameters and delegates to the gateway client via getServiceClient().
 */

import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { GetSensorStatusInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/GetSensorStatusInput'
import { GetSensorStatusOutput } from '@amzn/coral_com-amazon-ihmvirgo-coral/GetSensorStatusOutput'
import { GetSensorEntityInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/GetSensorEntityInput'
import { GetSensorEntityOutput } from '@amzn/coral_com-amazon-ihmvirgo-coral/GetSensorEntityOutput'
import { GetSensorsInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/GetSensorsInput'
import { GetSensorsOutput } from '@amzn/coral_com-amazon-ihmvirgo-coral/GetSensorsOutput'
import { AttachSensorInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/AttachSensorInput'
import { DetachSensorInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/DetachSensorInput'
import { ValidateSensorInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/ValidateSensorInput'
import { PutSensorInitializationDataInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/PutSensorInitializationDataInput'
import { validateRequired, validateRequiredNumeric } from './listenerUtils'

export async function getSensorStatusListener (message: any): Promise<GetSensorStatusOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'sensorId', 'storeId')
    const client = getServiceClient()
    return client.getSensorStatus(GetSensorStatusInput.clone(params)).toPromise()
}

export async function getSensorEntityListener (message: any): Promise<GetSensorEntityOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'sensorId', 'storeId')
    const client = getServiceClient()
    return client.getSensorEntity(GetSensorEntityInput.clone(params)).toPromise()
}

export async function getSensorsListener (message: any): Promise<GetSensorsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getSensors(GetSensorsInput.clone(params)).toPromise()
}

export async function attachSensorListener (message: any): Promise<void> {
    const params = (message && message.data) || {}
    validateRequired(params, 'sensorId', 'fixtureId', 'storeId')
    validateRequiredNumeric(params, 'startTime', 'endTime')
    const client = getServiceClient()
    await client.attachSensor(AttachSensorInput.clone(params)).toPromise()
}

export async function detachSensorListener (message: any): Promise<void> {
    const params = (message && message.data) || {}
    validateRequired(params, 'sensorId', 'fixtureId', 'storeId')
    validateRequiredNumeric(params, 'startTime', 'endTime')
    const client = getServiceClient()
    await client.detachSensor(DetachSensorInput.clone(params)).toPromise()
}

export async function validateSensorListener (message: any): Promise<void> {
    const params = (message && message.data) || {}
    validateRequired(params, 'sensorId', 'storeId')
    const client = getServiceClient()
    await client.validateSensor(ValidateSensorInput.clone(params)).toPromise()
}

export async function putSensorInitializationDataListener (message: any): Promise<void> {
    const params = (message && message.data) || {}
    validateRequired(params, 'sensorId', 'storeId')
    validateRequiredNumeric(params, 'angle')
    const client = getServiceClient()
    await client.putSensorInitializationData(PutSensorInitializationDataInput.clone(params)).toPromise()
}
